import { createAction, props } from "@ngrx/store";
import { PiPoint } from "../../models/pi-data.model";

export const loadLatestPiData = createAction('[PiData] Load Pis Data', props<{ equipementId: string }>());
export const loadLatestPiDataSuccess = createAction(
  '[PiData] Load Pi Data Success',
  props<{ piData: any[] }>()
);
export const loadLatestPiDataFailure = createAction(
  '[PiData] Load Pi Data Failure',
  props<{ error: any }>()
);

export const addSelectedPiPoint = createAction(
  '[PiData] Add Selected Pi Point',
  props<{ piPoint: PiPoint }>()
);

export const addSelectedPiPointv = createAction(
  '[PiData] Add Selected Pi Point',
  props<{ piPoint: PiPoint }>()
);

export const removeSelectedPiPoint = createAction(
  '[PiData] Remove Selected Pi Point',
  props<{ piPoint: PiPoint }>()
);

export const clearSelectedPiPoints = createAction(
  '[PiData] Clear Selected Pi Points'
);

export const setSelectedPiPoints = createAction(
  '[PiData] Set Selected Pi Points',
  props<{ piPoints: PiPoint[] }>()
);

export const validatePiPoint = createAction(
  '[PiData] Validate Pi Point',
  props<{ searchTerm: string }>()
);

export const validatePiPointSuccess = createAction(
  '[PiData] Validate Pi Point Success',
  props<{ searchTerm: string; isValid: boolean }>()
);

export const validatePiPointFailure = createAction(
  '[PiData] Validate Pi Point Failure',
  props<{ searchTerm: string; error: any }>()
);

export const resetPiPointValidation = createAction(
  '[PiData] Reset Pi Point Validation'
);

export const loadPiPointsByRuleId = createAction(
  '[PiData] Load Pi Points By Rule ID',
  props<{ ruleUid: string }>()
);

export const loadPiPointsByRuleIdSuccess = createAction(
  '[PiData] Load Pi Points By Rule ID Success',
  props<{ piPoints: PiPoint[] }>()
);

export const loadPiPointsByRuleIdFailure = createAction(
  '[PiData] Load Pi Points By Rule ID Failure',
  props<{ error: any }>()
);

export const setLiveCode = createAction(
  '[PiData] Set Live Code',
  props<{ componentId: string; code: string }>()
);
